import { buildURL } from 'react-imgix';
import parseImgix from './parseImgix';

export type ImgixImageParams = Record<string, string | number | boolean>;

export const buildImgixImageUrl = (
  url?: string | null,
  params: ImgixImageParams = {}
): string | undefined => {
  if (!url) return undefined;

  try {
    const parsed = parseImgix(url);
    if (!parsed) return undefined;

    return buildURL(parsed, { auto: 'format,compress', ...params });
  } catch {
    return undefined;
  }
};
